import React from "react";
import Skeleton from "@mui/material/Skeleton";
import { useWindowSize } from "usehooks-ts";

interface MediaSkeletonProps {
  mediaType?: "image" | "video" | "dom-replay";
}

const MediaSkeleton: React.FC<MediaSkeletonProps> = () => {
  const { width } = useWindowSize();
  const isDesktop = width > 1023;
  const dividerPosition = 65;

  return (
    <div
      className={`flex ${
        isDesktop ? "flex-row h-screen" : "flex-col"
      } relative ${isDesktop ? "gap-0" : "gap-4"} ${
        isDesktop ? "p-4 pt-[64px]" : "p-4"
      }`}
    >
      {/* Left side - Media viewer area */}
      <div
        className={`flex items-center ${isDesktop ? "h-full" : "h-screen"}`}
        style={{ width: isDesktop ? `${dividerPosition}%` : "100%" }}
      >
        {/* Main media area - one big skeleton */}
        <div className="flex w-full h-[80%] justify-center items-center px-0 lg:px-[56px]">
          <Skeleton
            sx={{ bgcolor: "rgba(255, 255, 255, 0.05)" }}
            className="rounded-lg"
            variant="rectangular"
            height="100%"
            width="100%"
          />
        </div>
      </div>

      {/* Divider - only on desktop */}
      {isDesktop && (
        <div className="w-[8px] hidden lg:flex items-center justify-center" />
      )}

      {/* Right side - Sidebar area */}
      <div
        style={{ width: isDesktop ? `${100 - dividerPosition}%` : "100%" }}
        className={`flex flex-col ${
          !isDesktop ? "h-auto pb-4" : "h-full"
        }`}
      >
        <Skeleton
          sx={{ bgcolor: "rgba(255, 255, 255, 0.05)" }}
          className="rounded-[24px]"
          variant="rectangular"
          height="100%"
          width="100%"
        />
      </div>
    </div>
  );
};

export default MediaSkeleton;
